import { useState, useEffect } from "react";
import { useGetAllNamirniceQuery } from "../features/Namirnice/namirniceApiSlice";
import { useGetIshraneNamesQuery } from "../features/ishrana/ishranaApiSlice";

const faqs = [
  {
    id: 1,
    question: "What's the best thing about Switzerland?",
    answer:
      "I don't know, but the flag is a big plus. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.",
  },
  {
    id: 2,
    question: "What's the best thing about Switzerland?",
    answer:
      "I don't know, but the flag is a big plus. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.",
  },
  {
    id: 3,
    question: "What's the best thing about Switzerland?",
    answer:
      "I don't know, but the flag is a big plus. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.",
  },
  {
    id: 4,
    question: "What's the best thing about Switzerland?",
    answer:
      "I don't know, but the flag is a big plus. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.",
  },
  {
    id: 5,
    question: "What's the best thing about Switzerland?",
    answer:
      "I don't know, but the flag is a big plus. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.",
  },
  {
    id: 6,
    question: "What's the best thing about Switzerland?",
    answer:
      "I don't know, but the flag is a big plus. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.",
  },
  // More questions...
];

const namirnice = [
  {
    _id: "67178db4782070c626c83861",
    naziv: "Cvekla",
    grupa: "Povrće",
    podtip: "Korenito",
    laktoza: false,
    gluten: false,
    alergen: false,
    ishrane: ["Kreirana ishrana", "Raznovrsna ishrana", "Test"],
  },
  // Druge namirnice...
];

const availableIshrane = [
  "Kreirana ishrana",
  "Raznovrsna ishrana",
  "Test",
  "Vegetarijanska",
];

function LongSection() {
  //Za tabelu namirnica
  const [namirnice, setNamirnice] = useState([]);
  const [availableIshrane, setAvailableIshrane] = useState([]);

  const {
    isSuccess: isSuccessGetNamir,
    isError: isErrorGetNamir,
    error: getNamirError,
    data: getNamirData,
  } = useGetAllNamirniceQuery();

  const {
    isSuccess: isSuccessGetIshName,
    isError: isErrorGetIshName,
    error: getIshNameError,
    data: getIshNameData,
  } = useGetIshraneNamesQuery();

  useEffect(() => {
    if (isSuccessGetNamir) {
      setNamirnice(Object.values(getNamirData.entities || {}));
    }

    if (isErrorGetNamir) {
      const errorMessage = getNamirError?.data?.message;
      alert(errorMessage);
    }
  }, [isSuccessGetNamir, isErrorGetNamir, getNamirError, getNamirData]);

  useEffect(() => {
    if (isSuccessGetIshName) {
      // console.log("Podaci o ishranama (getIshNameData):", getIshNameData);

      if (Array.isArray(getIshNameData)) {
        setAvailableIshrane(getIshNameData);
      } else if (getIshNameData && getIshNameData.entities) {
        setAvailableIshrane(Object.values(getIshNameData.entities));
      } else {
        setAvailableIshrane([]);
      }
    }

    if (isErrorGetIshName) {
      const errorMessage = getIshNameError?.data?.message;
      alert(errorMessage);
    }
  }, [isSuccessGetIshName, isErrorGetIshName, getIshNameError, getIshNameData]);

  useEffect(() => {
    // console.log("Dostupne ishrane:", availableIshrane);
  }, [availableIshrane]);
  //Za tabelu namirnica

  return (
    <>
      <div className="flex items-center justify-center h-screen bg-cover bg-center pozadina">
        <div className="bg-opacity-90 text-center">
          {/* Green Button */}
          <button className="px-6 py-2 bg-green-500 text-white font-semibold rounded-md hover:bg-green-600">
            Click Me
          </button>
          {/* SVG/Image */}
          <div className="flex items-center justify-center mt-4">
            <img
              src={`${process.env.PUBLIC_URL}/img/lapifonzahome11.png`}
              alt="Logo"
              className="w-[600px] h-auto object-contain" // Increased width
            />
          </div>
        </div>
      </div>

      {/* Glavni kontejner sa overflow-x-hidden za sprečavanje horiz. scrolla */}
      <div
        className="w-full overflow-x-hidden"
        style={{ backgroundColor: "#0000FF" }}
      >
        {/* Zelena linija na vrhu */}
        <div className="w-full h-3" style={{ backgroundColor: "#66BB6A" }} />

        {/* Glavni sadržaj */}
        <div className="bg-white">
          {/* Opis aplikacije */}
          <div className="text-center bg-white">
            {/* Naslov sa zelenim tačkama i linijom */}
            <div className="relative">
              <div
                aria-hidden="true"
                className="absolute inset-0 flex items-center"
              >
                <div className="flex-grow border-t border-black border-2" />
              </div>
              <div className="relative flex items-center justify-center">
                <div
                  className="w-2 h-2 rounded-full"
                  style={{ backgroundColor: "#66BB6A" }}
                />
                <h2 className="bg-white px-2 text-2xl font-bold text-black">
                  NutriTrans
                </h2>
                <div
                  className="w-2 h-2 rounded-full"
                  style={{ backgroundColor: "#66BB6A" }}
                />
              </div>
            </div>

            <p className="px-4 text-lg font-medium text-black">
              NutriTrans nije samo aplikacija za ishranu to je vaš vodič ka
              sveobuhvatnom zdravlju. Gledamo na vaše telo, um, i duh kao
              povezane celine, pomažući vam da uravnotežite ishranu, smanjite
              stres i pronađete unutrašnju harmoniju. Vaša transformacija
              počinje iznutra, a NutriTrans je tu da vas podrži na svakom koraku
              ka zdravijem i ispunjenijem životu.
            </p>

            {/* Lista sa stavkama */}
            <ul
              role="list"
              className="bg-white max-w-2xl mx-auto mt-8 p-4 sm:p-6 space-y-8 divide-y"
            >
              {[
                {
                  img: `${process.env.PUBLIC_URL}/img/mainPicture1.jpg`,
                  text: "Potpuno personalizovani planovi ishrane Svaki plan se kreira na osnovu unetih podataka korisnika, uključujući težinu, visinu, ciljeve, preferencije i zdravstvene parametre, garantujući rešenja koja odgovaraju individualnim potrebama.",
                },
                {
                  img: `${process.env.PUBLIC_URL}/img/mainPicture2.jpg`,
                  text: "Podrška veštačke inteligencije (AI) NutriTrans koristi napredne AI algoritme kako bi analizirao podatke i ponudio najsavremenije preporuke za zdravlje, mršavljenje ili održavanje forme, sa garantovanom tačnošću i efikasnošću.",
                },
                {
                  img: `${process.env.PUBLIC_URL}/img/mainPicture3.jpg`,
                  text: "Jednostavnost i pristupačnost Dizajniran za korisnike svih nivoa tehničke pismenosti, NutriTrans pruža intuitivan interfejs, brze rezultate i jednostavne korake za korišćenje – bez stresa ili konfuzije.",
                },
                {
                  img: `${process.env.PUBLIC_URL}/img/mainPicture4.jpg`,
                  text: "Širok fokus na zdravlje i holistički pristup Aplikacija ne samo da pomaže u mršavljenju, već podržava celokupno zdravlje kroz savete za ishranu, fizičku aktivnost, san, i mentalnu ravnotežu, osiguravajući trajne promene u životnom stilu.",
                },
                {
                  img: `${process.env.PUBLIC_URL}/img/mainPicture5.jpg`,
                  text: "Transparentnost i merenje rezultata Korisnici dobijaju detaljne izveštaje o svom napretku sa grafikonima, statistikom i analizama, čime se jasno prikazuje kako se ostvaruju njihovi ciljevi kroz vreme.",
                },
              ].map((item, index) => (
                <li
                  key={index}
                  className="flex flex-col gap-4 sm:flex-row sm:items-center"
                >
                  <img
                    src={item.img}
                    className="w-full sm:w-36 h-auto rounded-2xl object-cover" //px-4 text-lg font-medium text-black
                    alt={`Image ${index + 1}`}
                  />
                  <p className="text-gray-700 font-medium text-left">
                    {item.text}
                  </p>
                </li>
              ))}
            </ul>
          </div>

          {/* Naslov Blog */}
          <div className="relative">
            <div
              aria-hidden="true"
              className="absolute inset-0 flex items-center"
            >
              <div className="flex-grow border-t border-black border-2" />
            </div>
            <div className="relative flex items-center justify-center">
              <div
                className="w-2 h-2 rounded-full"
                style={{ backgroundColor: "#66BB6A" }}
              />
              <h2 className="bg-white px-11 text-2xl font-bold text-black">
                Blog
              </h2>
              <div
                className="w-2 h-2 rounded-full"
                style={{ backgroundColor: "#66BB6A" }}
              />
            </div>
          </div>

          {/* Dve kolone: Tekst i slika */}
          <div className="flex flex-col md:flex-row mt-4 gap-6">
            {/* Leva kolona */}
            <div className="flex-1 p-4">
              <h3 className="text-xl font-bold">
                Uz NutriTrans, niste same na putu ka zdravlju i blagostanju!
              </h3>
              <p className="mt-2 text-gray-700">
                Nutritrans je vise od aplikacije za ishranu, ona je vaš
                saosećajni saputnik koji razume jedinstvene potrebe vašeg tela,
                uma i duha. Kroz inovativnu snagu veštačke inteligencije,
                personalizujemo vaše iskustvo kako bismo vam pomogli da
                uravnotežite ishranu, smanjite stres i pronađete unutrašnji mir.
                Vaša transformacija počinje iznutra, a NutriTrans je tu da vas s
                ljubavlju podrži na svakom koraku ka zdravijem i ispunjenijem
                životu.
              </p>
              <button
                className="mt-4 text-black px-4 py-2 rounded font-bold"
                style={{ backgroundColor: "#66BB6A" }}
              >
                Start for free
              </button>
            </div>

            {/* Desna kolona */}
            <div className="flex-1 p-4">
              <img
                src={`${process.env.PUBLIC_URL}/img/landingImage.jpg`}
                alt="Descriptive Alt Text"
                className="w-full h-auto rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Zelena linija na dnu */}
      <div className="w-full h-3" style={{ backgroundColor: "#66BB6A" }} />

      {/* Citati sa vertikalnom linijom */}
      <div className="flex flex-col md:flex-row items-center h-auto gap-4 p-4">
        {/* Prvi citat */}
        <div className="flex-1 flex flex-col items-center justify-center text-center">
          <p className="italic">
            "Neka hrana bude tvoj lek, a lek tvoja hrana."
          </p>
          <p>Hipokrat</p>
        </div>

        {/* Vertikalna linija */}
        <div className="hidden md:flex items-center relative">
          <div
            className="absolute w-2 h-2 rounded-full top-[-4px] left-[5px]"
            style={{ backgroundColor: "#66BB6A" }}
          />
          <div className="w-0.5 h-24 bg-black mx-2" />
          <div
            className="absolute w-2 h-2 rounded-full bottom-[-4px] left-[5px]"
            style={{ backgroundColor: "#66BB6A" }}
          />
        </div>

        {/* Drugi citat */}
        <div className="flex-1 flex flex-col items-center justify-center text-center">
          <p className="italic">
            "Kvalitet tvoje ishrane određuje kvalitet tvog života."
          </p>
          <p>Dr. Joel Fuhrman</p>
        </div>
      </div>

      <div className="w-full h-3" style={{ backgroundColor: "#66BB6A" }} />

      {/* FAQ sekcija */}
      <div className="">
        <div className="mx-auto max-w-full divide-y divide-green-500 divide-[2px] px-6 py-12 sm:py-16 lg:px-8 lg:py-10">
          <h2 className="text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
            Frequently asked questions
          </h2>
          <dl className="mt-6 space-y-6 divide-y divide-green-500 divide-[2px]">
            {faqs.map((faq) => (
              <div
                key={faq.id}
                className="pt-4 lg:grid lg:grid-cols-12 lg:gap-8"
              >
                <dt className="text-base font-semibold leading-7 text-gray-900 lg:col-span-5">
                  {faq.question}
                </dt>
                <dd className="mt-2 lg:col-span-7 lg:mt-0">
                  <p className="text-base leading-7 text-gray-600">
                    {faq.answer}
                  </p>
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </>
  );
}

export default LongSection;

{
  /* <div className="flex items-center my-4 h-32">
<div className="flex-1 flex items-center justify-center">
    <div className="w-2 h-2 bg-green-500 rounded-full mr-2" />
    <p className="text-center">Left Centered Text</p>
</div>

<div className="flex items-center relative">
    <div className="absolute w-2 h-2 bg-green-500 rounded-full top-[-4px] left-[5px]" />
    <div className="w-0.5 h-24 bg-black mx-2" />
    <div className="absolute w-2 h-2 bg-green-500 rounded-full bottom-[-4px] left-[5px]" />
</div>

<div className="flex-1 flex items-center justify-center">
    <p className="text-center">Right Centered Text</p>
    <div className="w-2 h-2 bg-green-500 rounded-full ml-2" />
</div>
</div> */
}

// src={`${process.env.PUBLIC_URL}/img/landingImage.jpg`}

{
  /* <p className="mt-2 text-gray-700">Nutritrans je vise od aplikacije za ishranu, ona je vaš saosećajni 
                saputnik koji razume jedinstvene potrebe vašeg tela, uma i duha. Kroz inovativnu snagu veštačke 
                inteligencije, personalizujemo vaše iskustvo kako bismo vam pomogli da uravnotežite ishranu, 
                smanjite stres i pronađete unutrašnji mir. Vaša transformacija počinje iznutra, a NutriTrans je 
                tu da vas s ljubavlju podrži na svakom koraku ka zdravijem i ispunjenijem životu.</p>  */
}

// <h3 className="text-xl font-bold">Uz NutriTrans, niste same na putu ka zdravlju i blagostanju</h3>

{
  /*

<div className="relative">
    <div aria-hidden="true" className="absolute inset-0 flex items-center">
        <div className="flex-grow border-t border-black border-2" />
    </div>
    <div className="relative flex items-center justify-center">
        <div className="w-2 h-2 bg-green-500 rounded-full" />
        <h2 className="bg-white px-2 text-2xl font-bold text-black">NutriTrans</h2>
        <div className="w-2 h-2 bg-green-500 rounded-full" />
    </div>
</div>

*/
}

{
  /* <div className="relative">
<div aria-hidden="true" className="absolute inset-0 flex items-center">
    <div className="flex-grow border-t border-black border-2" />
</div>
<div className="relative flex items-center justify-center">
    <div className="w-2 h-2 bg-green-500 rounded-full" />
    <h2 className="bg-white px-2 text-2xl font-bold text-black">NutriTrans</h2>
    <div className="w-2 h-2 bg-green-500 rounded-full" />
</div>
</div>

<div className="text-center my-5 px-5">
<p className="text-sm font-medium text-black">NutriTrans nije samo aplikacija za ishranu 
    to je vaš vodič ka sveobuhvatnom zdravlju. Gledamo na vaše telo, um, i duh kao povezane celine, 
    pomažući vam da uravnotežite ishranu, smanjite stres i pronađete unutrašnju harmoniju. 
    Vaša transformacija počinje iznutra, a NutriTrans je tu da vas podrži na svakom koraku ka zdravijem 
    i ispunjenijem životu.
</p>
</div>

<div className="relative">
<div aria-hidden="true" className="absolute inset-0 flex items-center">
    <div className="flex-grow border-t border-black border-2" />
</div>
<div className="relative flex items-center justify-center">
    <div className="w-2 h-2 bg-green-500 rounded-full" />
    <h2 className="bg-white px-11 text-2xl font-bold text-black">Blog</h2> {/* Još veći padding */
}
//     <div className="w-2 h-2 bg-green-500 rounded-full" />
// </div>
// </div> */}
